/**
 * Full-screen cinematic "ARIA is thinking" moment.
 * Activates while a heavy chat reply is streaming. Dimmed page, magenta scanlines,
 * center-floating orb, tokens streaming below the orb.
 *
 * Triggered when the user's last message has _streaming === true.
 * Auto-collapses to inline as soon as content arrives (>40 chars) so the user
 * can read the full reply normally.
 */
import { AriaOrb } from "./AriaOrb";

export default function ThinkingStage({ active, partial }) {
  if (!active) return null;
  return (
    <div
      className="fixed inset-0 z-[60] pointer-events-none flex flex-col items-center justify-center thinking-stage fade-in"
      data-testid="thinking-stage"
      aria-live="polite"
    >
      <div className="absolute inset-0 bg-[var(--aria-bg)]/72 backdrop-blur-md" />
      <div className="absolute inset-0 thinking-scanlines pointer-events-none" />
      <div className="absolute inset-0 thinking-aurora pointer-events-none" />
      <div className="absolute inset-x-0 top-[40%] thinking-band" />
      <div className="absolute inset-x-0 top-[60%] thinking-band thinking-band-2" />

      <div className="relative z-10 flex flex-col items-center text-center px-6">
        <div className="relative">
          <AriaOrb size={160} state="thinking" />
          <div className="absolute -inset-10 rounded-full border border-[var(--aria-primary)]/30 animate-[jarvis-spin_6s_linear_infinite]" />
          <div className="absolute -inset-16 rounded-full border border-[var(--aria-accent)]/22 animate-[jarvis-spin_10s_linear_infinite_reverse]" />
        </div>
        <div className="mt-10 font-mono text-[10px] tracking-[0.32em] text-[var(--aria-primary)] uppercase">
          ◆ ARIA · synthesizing
        </div>
        <div className="mt-3 max-w-2xl text-lg md:text-xl text-[var(--aria-text)] font-display font-medium leading-snug min-h-[2.6rem] tracking-tight">
          {partial || <span className="text-[var(--aria-text-faint)] italic">retrieving relevant protocols…</span>}
          <span className="stream-cursor align-middle" aria-hidden />
        </div>
      </div>
    </div>
  );
}
